export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";